import styled from '@emotion/styled/macro';

export const BackButton = styled.button`
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: 8px;
    padding: 10px 20px;
    margin: 16px 16px;
    background: ${props => props.theme.colours.textGreen};
    border: 2px solid ${props => props.theme.colours.textGreen};
    border-radius: 8px;
    color: ${props => props.theme.colours.textWhite};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.normal};
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: transparent;
        color: ${props => props.theme.colours.textGreen};
    }
`;

export const Arrow = styled.span`
    font-size: 20px;
    line-height: 1;
`;
